import axios from "axios";
import api from "../../lib/api";
export default {
  namespaced: true,
  state: {
    clients: [],
    client: {
      isActive: true,
      v3: {
        url: "",
        ip: "",
        webPort: null,
        nodePort: null,
        appPort: null,
        sqlPort: null
      },
      // server: {},
      phones: [],
      emails: []
    }
  },
  mutations: {
    setOne(state, payload) {
      state.client = payload;
    },
    clear(state) {
      state.client = {};
    }
  },
  actions: {
    delete({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${api()}/clients/${payload}`)
          .then(res => {
            commit("clear");
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    },
    getOne({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios(`${api()}/clients/${payload}`)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    },
    save({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${api()}/clients/${payload._id}`, payload)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    },
    create({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${api()}/clients/`, payload)
          .then(res => {
            commit("setOne", res.data);
            resolve(res.data);
          })
          .catch(err => {
            // console.warn(err);
            reject(err);
          });
      });
    }
  },
  getters: {
    client: state => state.client,
    clients: state => state.clients
  }
};
